// styles
import classnames from 'classnames/bind';
import Button from 'components/Button';
import RemoveButton from 'components/Button/RemoveButton';
// components
import RemoveModal from 'components/instances/RemoveModal';
// import ClassCode from 'components/ClassCode';
import Table from 'components/Table';
import Typography from 'components/Typography';
import ManagementWrapper from 'containers/ManagementWrapper';
import { isEmpty } from 'lodash';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ADD_CLASS_FULL, ClASSESS_FULL, getManageClassRoute } from 'routes';
import { removeClassroom } from 'store/actions/user';
import { alphabeticalSort } from 'utils/sort';

import styles from './Classes.module.scss';

const cx = classnames.bind(styles);

const Classes = () => {
  const [classToRemove, setClassToRemove] = useState({});
  const { classrooms = [] } = useSelector(({ user }) => user);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const crumbs = { 'all classes': ClASSESS_FULL };

  const classRenderer = ({ name, id }) => (
    <Typography className={cx('class-name')} onClick={() => navigate(getManageClassRoute(id))} type="h5">
      {name}
    </Typography>
  );
  const codeRenderer = ({ students }) => <Typography>{students.length || '-'}</Typography>;
  const deleteClassRenderer = (props) => (
    <div className={cx('remove-wrapper')}>
      <RemoveButton onClick={() => setClassToRemove(props)} />
    </div>
  );

  const columns = [
    { name: 'Class', width: 400, renderer: classRenderer, sortFunction: alphabeticalSort('name') },
    { name: 'Students', width: 440, renderer: codeRenderer },
    { name: '', width: 100, renderer: deleteClassRenderer },
  ];

  const handleRemoveClass = () => dispatch(removeClassroom(classToRemove?.id, () => setClassToRemove({})));

  return (
    <ManagementWrapper breadcrumbs={crumbs}>
      <div className={cx('heading-wrapper')}>
        <Typography type="h4">All Classes</Typography>

        <Button label="+ NEW CLASS" onClick={() => navigate(ADD_CLASS_FULL)} />
      </div>

      <Table data={classrooms} columns={columns} />

      <RemoveModal
        isOpen={!isEmpty(classToRemove)}
        onClose={() => setClassToRemove({})}
        subject={classToRemove?.name}
        onConfirm={handleRemoveClass}
      />
    </ManagementWrapper>
  );
};

export default Classes;
